<div fxLayout="row" class="header" fxLayoutAlign="start start">
  <h1>{{ 'settings.my-invites.invites' | translate }}</h1>
</div>

<router-outlet></router-outlet>
